import React from 'react';

import ClearOutlined from '@mui/icons-material/ClearOutlined';
import EditOutlined from '@mui/icons-material/EditOutlined';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import { Alert, AlertTitle, List, ListItem, ListItemText } from '@mui/material';

import { InfoBox } from '@/components/InfoBox';

export const EditBanner = () => {
  return (
    <InfoBox>
      <Alert
        icon={
          <EditOutlined
            sx={theme => ({
              fontSize: '20px',
              color: theme.palette.primary.main
            })}
          />
        }
        severity='info'
        sx={{
          backgroundColor: 'inherit',
          color: 'inherit'
        }}
      >
        <AlertTitle
          sx={{
            fontSize: '16px',
            fontWeight: 700,
            mb: '8px'
          }}
        >
          Edit Mode
        </AlertTitle>
        <List
          disablePadding
          sx={{
            listStyleType: 'square',
            pl: 2,
            '& .MuiListItemText-primary': {
              fontSize: '14px'
            },
            '& .MuiListItem-root': {
              display: 'list-item',
              p: 0
            },
            '& .MuiListItem-root::marker': {
              fontSize: '8px'
            }
          }}
        >
          <ListItem>
            <ListItemText primary='Drag widgets/tabs to reorder' />
          </ListItem>
          <ListItem>
            <ListItemText
              primary={
                <>
                  Use "{' '}
                  <SettingsOutlined
                    sx={{
                      fontSize: '8px'
                    }}
                  />{' '}
                  " icon for settings, "
                  <ClearOutlined
                    sx={{
                      fontSize: '8px'
                    }}
                  />
                  " to remove, "+" to add a new tab
                </>
              }
            />
          </ListItem>
          <ListItem>
            <ListItemText primary='Click "Save" when done' />
          </ListItem>
        </List>
      </Alert>
    </InfoBox>
  );
};
